<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.07 90.07">
    <rect class="cls-1" x="0" y="0" width="90.07" height="90.07"/>
    <g>
      <path class="cls-2" d="M36.43,9.95l-22.58,6.13c-1.56,.42-2.69,1.77-2.82,3.38l-1.99,23.3c-.11,1.24,.4,2.47,1.36,3.28l43.46,36.27c1.63,1.36,4.06,1.14,5.42-.49l24.56-29.43c1.36-1.63,1.14-4.06-.49-5.42L39.9,10.71c-.97-.81-2.27-1.09-3.47-.76Zm-12.04,17.78c-1.45,1.74-4.04,1.98-5.78,.53s-1.97-4.04-.52-5.78,4.04-1.97,5.78-.52,1.97,4.04,.52,5.78Z"/>
      <g>
        <path class="cls-3" d="M65.27,44.18l-2.02,2.42c.88,.88,1.62,1.81,2.23,2.79,.61,.98,1.04,1.93,1.28,2.86l-3.74,2.21c-.27-.99-.73-1.99-1.39-2.98-.66-1-1.44-1.88-2.35-2.63s-1.65-1.16-2.22-1.22c-.58-.06-1.02,.1-1.32,.46-.26,.31-.35,.67-.28,1.09,.07,.42,.38,.98,.91,1.67l2.04,2.6c2.19,2.85,2.32,5.43,.39,7.74-1.03,1.23-2.31,1.93-3.85,2.09-1.54,.17-3.12-.2-4.73-1.1l-2.11,2.53-3.05-2.55,2.05-2.46c-.69-.72-1.26-1.52-1.73-2.37-.46-.86-.75-1.68-.86-2.47l3.53-2.04c.19,.85,.54,1.69,1.07,2.51,.53,.83,1.2,1.58,2.02,2.27,.76,.64,1.47,.99,2.13,1.07,.66,.07,1.17-.11,1.53-.54,.24-.29,.33-.64,.24-1.05-.08-.4-.38-.94-.89-1.61l-2.02-2.62c-2.24-2.88-2.41-5.45-.53-7.71,1.04-1.24,2.32-1.94,3.85-2.07s3.07,.23,4.63,1.11l2.11-2.53,3.05,2.55Z"/>
        <path class="cls-3" d="M49.32,30.87l-2.02,2.42c.88,.88,1.62,1.81,2.23,2.79,.61,.98,1.04,1.93,1.28,2.86l-3.74,2.21c-.27-.99-.73-1.99-1.39-2.98-.66-1-1.44-1.88-2.35-2.63s-1.65-1.16-2.22-1.22c-.58-.06-1.02,.1-1.32,.46-.26,.31-.35,.67-.28,1.09,.07,.42,.38,.98,.91,1.67l2.04,2.6c2.19,2.85,2.32,5.43,.39,7.74-1.03,1.23-2.31,1.93-3.85,2.09-1.54,.17-3.12-.2-4.73-1.1l-2.11,2.53-3.05-2.55,2.05-2.46c-.69-.72-1.26-1.52-1.73-2.37-.46-.86-.75-1.68-.86-2.47l3.53-2.04c.19,.85,.54,1.69,1.07,2.51,.53,.83,1.2,1.58,2.02,2.27,.76,.64,1.47,.99,2.13,1.07,.66,.07,1.17-.11,1.53-.54,.24-.29,.33-.64,.24-1.05-.08-.4-.38-.94-.89-1.61l-2.02-2.62c-2.24-2.88-2.41-5.45-.53-7.71,1.04-1.24,2.32-1.94,3.85-2.07,1.53-.14,3.07,.23,4.63,1.11l2.11-2.53,3.05,2.55Z"/>
      </g>
    </g>
</svg>
</template>

<script>
export default {
    name: "PricingTableIcon",
}
</script>

<style scoped>
    .cls-1 {
      fill: #fff;
    }

    .cls-2 {
      fill: none;
      stroke: #59c5c7;
      stroke-miterlimit: 10;
      stroke-width: 4px;
    }

    .cls-3 {
      fill: #cfeae0;
    }
</style>